import axios from 'axios';
import { ADD_REMINDER,DEL_REMINDER,CLEAR_ALL_REMINDER, UPDATE_IDEA } from '../constants';
import { RECORD_LAP,DEL_LAP,CLEAR_ALL_LAP } from '../constants';
import { SIGNED_IN,SIGNED_OUT } from '../constants';
import { DEL_IDEA , GET_IDEA } from '../constants';


export const addReminder = (text,dueDate) => {
    const action = {
        type: ADD_REMINDER,
        text,
        dueDate
    }
    //console.log('action in addReminder',action);
    return action;

}

export const delReminder = (id) => {
    const action = {
        type: DEL_REMINDER,
        id
    }
    //console.log('action in delReminder',action)
    return action;
}

export const clearAll = () => {
    const action = {
        type: CLEAR_ALL_REMINDER
    }
    return action;
}

export const recordLap= (lap) => {
    const action = {
        type: RECORD_LAP,
        lap
    }
    //console.log('action in recordReminder',action);
    return action;
}

export const delLap = (id) => {
    const action = {
        type:DEL_LAP,
        id
    }
    return action;
}

export const clearAllLap = () => {
    const action = {
        type: CLEAR_ALL_LAP
    }
    return action;
}  


const insertUser = (user) =>{
    return fetch('https://36yqkvhab2.execute-api.us-east-1.amazonaws.com/Dev/new-user',{
        method:'POST',
        mode: "cors",
        headers:{
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(user)
    });
}

const insertIdea = (idea) => {
    return fetch('https://36yqkvhab2.execute-api.us-east-1.amazonaws.com/Dev/idea',{
        method:'POST',
        mode: "cors",
        headers:{
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(idea)
    });
}

export const getIdea = (id) => dispatch => {
    axios.get(`https://36yqkvhab2.execute-api.us-east-1.amazonaws.com/Dev/idea?id=${id}`)
         .then(res=>{
            //console.log(res);
            let r = (res.data.ideas.length>0)? 'success' : 'empty';
            let action = {
                type: GET_IDEA,
                ideas: res.data.ideas,
                result: r
            }
            dispatch(action);            
        }).catch(err=>{
            dispatch({
                type: GET_IDEA,
                ideas: [],
                result: 'error'
            });
        });
    
}

export const delIdea = (idea) =>  dispatch => {
    //`https://36yqkvhab2.execute-api.us-east-1.amazonaws.com/Dev/idea?user_id=${idea.user_id}&id=${idea.id}`
    axios.delete(`https://36yqkvhab2.execute-api.us-east-1.amazonaws.com/Dev/idea?user_id=${idea.user_id}&id=${idea.id}`)
         .then(res=>{
            let action = {
            type: DEL_IDEA,
            id:idea.id,
            result: res.data.message
        }
        dispatch(action);
        }).catch(err=>console.log(err));
}

export const updateIdea = (idea) => dispatch => {
    axios.put('https://36yqkvhab2.execute-api.us-east-1.amazonaws.com/Dev/idea',idea)
         .then(res=>{
            let action = {
                        type:UPDATE_IDEA,
                        idea,
                        result:res.data.message
                    }
                    dispatch(action);
         })
         .catch(err=>console.log(err));
    
}

export const logUser = (user) => dispatch =>  {
    insertUser(user).then(res=>{
        return res.json();
    }).then(res=>{
        //console.log(res);
        const action = {
            type: SIGNED_IN,
            user
        }
        dispatch(action);
    });
    
}

export const logoutUser = () => {
    const action = {
        type: SIGNED_OUT
    }
    return action;
}

export const submitIdea = (idea) => dispatch => {
    //console.log('idea',idea);
    insertIdea(idea).then(
        res=> {return res.json();
        }).then(res=>{
    }).catch(err=>console.log(err));
    
    
}


// WEBPACK FOOTER //
// ./src/actions/index.js